import { render, staticRenderFns } from "./AdminOnetimePayment.vue?vue&type=template&id=0cba4612&scoped=true"
import script from "./AdminOnetimePayment.vue?vue&type=script&lang=js"
export * from "./AdminOnetimePayment.vue?vue&type=script&lang=js"
import style0 from "./AdminOnetimePayment.vue?vue&type=style&index=0&id=0cba4612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba4612",
  null
  
)

export default component.exports